import { cn } from '@/lib/utils';
const NewAsset = ({
  className
}: {
  className?: string;
}) => <span className={cn('whitespace-nowrap rounded border-1 border-pink-100 border-solid bg-pink-50 px-1.5 font-heading font-semibold text-base text-pink-500 dark:border-pink-600 dark:bg-[#2E1E23]', className)} data-sentry-component="NewAsset" data-sentry-source-file="NewAsset.tsx">
    new
  </span>;
export default NewAsset;